<div class="wrapper d-flex flex-column align-items-center h-100 w-100 position-relative">
	<button class="btn btn-close d-flex" data-test-id="close-button" (click)="close.emit()">Close</button>

	<h2 class="title">Potential savings</h2>
	<div class="separator w-100 m-0"></div>
	<div class="total-savings d-flex flex-column align-items-center w-100 my-auto">
		<div class="total-savings__title mb-2">Total Savings</div>
		<!-- Monthly / Annual -->
		<div class="d-flex align-items-center justify-content-center mb-3">
			<span
				data-test-id="potential-savings-total-saving-monthly-button"
				class="btn-text"
				[class.active]="isMonthlyState"
				(click)="toggleIsMonthly(true)"
			>
				Monthly
			</span>
			<div class="divider">|</div>
			<span
				data-test-id="potential-savings-total-saving-annual-button"
				class="btn-text"
				[class.active]="!isMonthlyState"
				(click)="toggleIsMonthly(false)"
			>
				Annual
			</span>
		</div>
		<!-- Total Savings -->
		<div class="d-flex align-items-center">
			<div class="total-savings__value" [appCounter]="savings | currency : 'USD' : 'symbol' : '1.0-0'"></div>
		</div>
		<button
			data-test-id="apply-button"
			type="button"
			class="btn btn-apply mx-auto"
			[class.reverse]="isExtended"
			(click)="apply()"
		>
			{{ applyBtn }}
		</button>
	</div>
	<div class="separator w-100 m-0"></div>
	<div class="footer d-flex flex-column mt-4">
		<div class="data-origin text-center" data-test-id="data-origin-text">{{ dataOriginText }}</div>
		<div class="d-flex justify-content-center align-items-center">
			<div class="updated-at">This data was last updated on {{ data.updatedAt | dotDate }}</div>
			<button
				data-test-id="refresh-data-button"
				type="button"
				class="footer__link link-zesty"
				*ngIf="isRefreshDataAllowed"
				(click)="refreshData()"
			>
				Refresh data.
			</button>
		</div>
	</div>
	<div class="toggle-block">
		<input class="switcher" type="checkbox" data-label="EDP" [checked]="isEDP" (change)="onChange($event)" />
	</div>
</div>
